/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectFinancialClaimsDetailsCommand } from '../../models/create-project-financial-claims-details-command';
import { CreateProjectFinancialClaimsDetailsCommandResult } from '../../models/create-project-financial-claims-details-command-result';

export interface ApiProjectFinancialClaimsDetailsPost$Params {
  
    /**
     * Details of the Project Financial Claim to create.
     */
    body?: CreateProjectFinancialClaimsDetailsCommand
}

export function apiProjectFinancialClaimsDetailsPost(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialClaimsDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectFinancialClaimsDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialClaimsDetailsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectFinancialClaimsDetailsCommandResult>;
    })
  );
}

apiProjectFinancialClaimsDetailsPost.PATH = '/api/ProjectFinancialClaimsDetails';
